import Layout from "../Layout";
import { useHistory, useParams, } from "react-router";
import { useState, useEffect } from "react";

import './Reservations.css';
import { InputLogo } from "../../components/Input";

import {
    getFirestore,
    doc,
    getDoc
} from "@firebase/firestore";

import app from "../../utils/Firebase";


import {
    faUsers,
    faChild,
    faUser,
    faArrowLeft
} from "@fortawesome/free-solid-svg-icons";

import {
    faWhatsapp
}
from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const db = getFirestore(app);


export default function Reservations(){
    const history = useHistory();
    const { local_id } = useParams();

    let [local_number, setLocalNumber] = useState('');
    const [localData, setlocalData] = useState(null);

    useEffect( () => {
        obtenerMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    } , []);

    async function obtenerMenu(){
        const localesCol = doc(db, 'locales', local_id);
        const localeSnapshot = await getDoc(localesCol);
        const localData = localeSnapshot.data();
        console.log(localData);
        setlocalData(localData);
        setLocalNumber(localData.datos_contacto.telefono);
    }


    const makeReservation = evt =>{
        evt.preventDefault();
        console.log(evt);

        let numero_adultos = evt.target.numero_adultos.value;
        let numero_ninos = evt.target.numero_ninos.value;
        let fecha = evt.target.fecha.value;
        let hora = evt.target.hora.value;
        let quien_reserva = evt.target.nombre_reserva.value;

        let msj = `Hola buen dia. Me gustaria hacer una reservación:\n\n`;
        msj += `Fecha: *${fecha}*\n`;
        msj += `Hora: *${hora}*\n`
        msj += `Adultos: *${numero_adultos}*\n`
        msj += `${numero_ninos ? `Niños: *${numero_ninos}*\n`: ''}`;
        msj += `\nA nombre de *${quien_reserva}*.`;

        console.log(msj);

        let final_string = encodeURIComponent(msj);
        
        console.log(final_string);

        let link = `https://wa.me/521${local_number}?text=`+final_string;
        window.open(link);
    }

    const getSchedule = schedule_obj => {
        let schedule = [];
        let days = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];
        for(let day of days){
            let apertura = schedule_obj.horario[day].apertura;
            let cierre = schedule_obj.horario[day].cierre;
            let abierto = schedule_obj.horario[day].abierto;
            
            if(abierto)
                schedule.push(<tr className='schedule-item'><td className='schedule-day'><p>{day}</p></td><td className='schedule-time'><p> { apertura } - { cierre }</p></td></tr>);
            else
                schedule.push(<tr className='schedule-item'><td className='schedule-day'><p>{day}</p></td><td className='schedule-closed'><p>Cerrado</p></td></tr>);
        }
        return schedule;
    }

    return(
        <Layout local={ local_id }>
            { localData ? 
                <div className='booking-container'>
                    <h3>Reservación de mesa </h3>
                    <h4>{ localData.nombre }</h4>
                    <div className='schedule'>
                        <table className='schedule-container'>
                            { getSchedule(localData) }
                        </table>
                    </div>


                    <form onSubmit={ makeReservation }>
                        <div className='input-group input-group-numbers'>
                            <InputLogo name='numero_adultos' placeholder='Adultos' type='number' icon={ faUsers }/>
                            <InputLogo name='numero_ninos' placeholder='Niños' type='number' icon={ faChild }/>
                        </div>

                        <div className='input-group'>
                            <InputLogo name='fecha' placeholder='Fecha' type='date'/>
                            <InputLogo name='hora' placeholder='Hora' type='time'/>
                        </div>
                        
                        <div className='input-group'>
                            <InputLogo name='nombre_reserva' placeholder='Su nombre' fullWidth={ true } icon={ faUser }/>
                        </div>

                        
                        <div className='input-group-button' style={ { marginTop: 20 } }>
                            <button type='submit' className='whatsapp-button button__flat button__full-width button__green' ><FontAwesomeIcon icon={ faWhatsapp } size='lg'/> RESERVAR</button>
                            <button type='button' className='back-button button__flat button__full-width button__white' onClick={ () => { history.push('/La-esperanza') } }><FontAwesomeIcon icon={ faArrowLeft } size='lg'/> REGRESAR</button>
                        </div>
                    </form>
                </div>
            : null}
        </Layout>
    );
}